import { Platform, StyleSheet } from 'react-native';
import { Button, ButtonProps } from '../../Button';

type ButtonWithoutChildren = Omit<ButtonProps, 'children'>;
export type ActionProps = ButtonWithoutChildren & { label: string };

interface ModalActionsProps {
	primaryAction: ActionProps;
	secondaryAction: ActionProps;
}

export const ModalActions = ({ primaryAction, secondaryAction }: ModalActionsProps) => {
	return (
		<>
			<Button {...primaryActionDefaultProps} {...primaryAction}>
				{primaryAction.label}
			</Button>

			<Button {...secondaryActionDefaultProps} {...secondaryAction}>
				{secondaryAction.label}
			</Button>
		</>
	);
};

const styles = StyleSheet.create({
	webButton: {
		flex: 1,
	},
});

const primaryActionDefaultProps: ButtonWithoutChildren = Platform.select({
	web: {
		variant: 'filled',
		color: 'primary',
		style: styles.webButton,
	},
	default: {
		variant: 'outline',
		color: 'danger',
	},
});

const secondaryActionDefaultProps: ButtonWithoutChildren = {
	variant: 'outline',
	color: 'primary',
	style: Platform.select({ web: styles.webButton, default: null }),
};
